import React, { memo } from "react";
import { Spinner } from "react-bootstrap";

interface IProps {
  isLoading?: boolean;
}

const NoDataView: React.FC<IProps> = memo(({ isLoading }) => {
  return (
    <div className="no-data-view">
      {isLoading ? (
        <div className="spinner-container">
          <Spinner animation="border" data-testid="spinner">
            <span className="sr-only" />
          </Spinner>
        </div>
      ) : (
        <div className="">
          <p>No data</p>
        </div>
      )}
    </div>
  );
});

export { NoDataView };
